/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Tool_Confirm_Granted_ByInputs */



/**
* | output |
* | --- |
* | "Granted by {name}" |
*
* @param {Chat_Tool_Confirm_Granted_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_granted_by = /** @type {((inputs: Chat_Tool_Confirm_Granted_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Granted_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Genehmigt von ${i?.name}`)
	return /** @type {LocalizedString} */ (`Granted by ${i?.name}`)
});